module.exports = __webpack_public_path__ + "img/canvasMenu2.81f2ac08.svg";